const SE = {
  associationIncorporated: [
    "ekonomisk förening (Ek. för.)",
    "kooperativ hyresrättsförening (KHF)"
  ],
  partnershipIncorporated: [
    "kommanditbolag (KB)"
  ],
  partnershipUnincorporated: [
    "handelsbolag (HB)"
  ]
};
export {
  SE as default
};
